export default {
  name: 'webSocket',
  components: {},
  data() {
    //var url = window.location.host.split(':');
    return {
      ws: null,
      wsUrl: 'wss://zsmy.fyakm.com/socketIO/',
      //wsUrl: 'wss://'+url[0]+'/socketIO/',
      //wsUrl: 'ws://192.168.99.114:2133',
      lockReconnect: false,
      //是否真正建立连接
      timeout: 20 * 1000,
      //20秒一次心跳
      timeoutObj: null,
      //心跳心跳倒计时
      serverTimeoutObj: null,
      //心跳倒计时
      timeoutnum: null,
      //断开 重连倒计时
      isLoginData: {} //心跳数据
    };
  },

  mounted: function () {
    //console.log('socket...');
    var that = this;
    setTimeout(function () {
      that.initWebSocket();
    }, 200);
    //this.initWebSocket();
  },

  beforeUnmount: function () {
    this.websocketClose();
    //console.log('离开后：',this.ws.connected);
  },

  methods: {
    initWebSocket() {
      var that = this;
      this.ws = new WebSocket(this.wsUrl);
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        //console.log('已经连接了');
        return;
      }
      this.ws.onmessage = function (event) {
        //console.log(`收到消息：${event.data}`);
        //console.log(JSON.parse(event.data));
        if (event.data.type === 'ping') {
          // 响应心跳
          that.ws.send(JSON.stringify({
            type: 'ping'
          }));
        } else if (event.data) {
          that.$emit('callBack', JSON.parse(event.data));
        }
      };
      this.ws.onopen = function () {
        //console.log('开启socket...');
        that.websocketSendMessage(that.isLoginData);
      };
      this.ws.onerror = function (e) {
        console.log('socket error...', e);
      };
      // //连接关闭
      this.ws.onclose = function (e) {
        console.log('socket onclose...', e);
        that.initWebSocket();
      };
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      //console.log('开启心跳');
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        if (self.ws.readyState == 1) {
          //如果连接正常
          self.ws.send(JSON.stringify({
            type: 'ping'
          }));
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.ws.close();
        }, self.timeout);
      }, self.timeout);
    },
    websocketOpen: function () {
      if (!this.ws) {
        this.initWebSocket();
      }
    },
    websocketClose: function () {
      //var that = this;
      console.log('close....');
      this.ws.close();
      this.ws = null;
    },
    websocketError: function () {
      console.log('websocket onerror', this.ws.readyState);
      this.initWebSocket();
    },
    websocketSendMessage: function (e) {
      var that = this;
      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(e));
      } else {
        setTimeout(function () {
          that.websocketSendMessage(e);
        }, 1000);
      }
    },
    isLogin: function (isLoginData) {
      this.isLoginData = isLoginData;
    }
  }
};